import { GET_PRICE_PER_TICKET } from "../components/action-types"


const getPricePerTicketReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_PRICE_PER_TICKET):
            return state = action.payload
        default:
            return state
    }
}

export default getPricePerTicketReducer;